import { getChannel } from "@website/utils/channel/get-channel";
import { Channels } from "@website/utils/channel/types";

export const convertChannelPlatform = (channel: string = "web") => {
  if (["website"]?.includes(channel)) return "web";
  return channel;
};

export const isChannel = (channels: Array<Channels>): boolean =>
  Boolean(channels?.includes(getChannel() as Channels));
